import { WImage, WLink } from '@components/atoms'
import styles from './HeroStickyBar.module.sass'
import { trackingGAevent } from '@utils/gtm'

interface Props {
  className?: string
  label?: string
  logo?: string
  options?: { label?: string; url?: string }[]
}

const HeroStickyBar = (props: Props) => {
  const { options = [], logo = undefined, label = undefined, className = '' } = props

  const handleClickTracking = (item) => {
    trackingGAevent('click_menu_brand', {
      click_text: item?.label || '', //The clicked text
      click_url: item?.url || '', //The clicked links
    })
  }

  return options?.length ? (
    <div
      className={`${styles.root} ${className} ${styles[`root--${label ? 'label' : 'default'}`]}`}
    >
      <div className={styles.container}>
        {logo && (
          <div className={styles.logo}>
            <WImage src={logo} maxWidth={240} maxHeight={33} priority loading="eager" />
          </div>
        )}
        <div className={styles.links}>
          {options.map((item, index) => (
            <div className={styles.link} key={index}>
              <WLink next={false} href={item.url} onClick={() => handleClickTracking(item)}>
                {item.label}
              </WLink>
            </div>
          ))}
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default HeroStickyBar
